import React from "react";

export default function BrandServices() {

    return (

        <div>

            <h1>Services</h1>

            <p>Services module coming soon.</p>

        </div>

    );

}